import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';
import { usePageCopy } from '#src/app/pages/psf/promoteOrShare/shared/hooks';

type Result = ModelHookResult<{
	displayed: boolean;
	heading: string;
	text: string;
}>;

const MIN_PROMOTERS = 5;

export function useJoinTheCommunity(): Result {
	const {
		data: {
			petition: { promotionStats },
			joinTheCommunityCustomConfig,
			promoteShareOnComboExperiment,
		},
	} = usePsfPromoteOrSharePageData();
	const {
		data: { promoterCountHeading, promoterCountText },
	} = usePageCopy();
	const { translate, translatePlural } = useI18n();

	return {
		data: {
			displayed:
				promotionStats.promoterCount >= MIN_PROMOTERS &&
				(promoteShareOnComboExperiment.variation === 'control' ||
					promoteShareOnComboExperiment.variation === 'fake_control'),
			heading: promoterCountHeading,
			text: useMemo(() => {
				if (!joinTheCommunityCustomConfig) return promoterCountText;
				const {
					promoterCount,
					promoterCountLocalized,
					contributionAmountLocalized,
					additionalSignatures,
					additionalSignaturesLocalized,
				} = joinTheCommunityCustomConfig;
				return translate('fe.components.psf.promote_or_share.promoted_contributor_amount_combined', {
					hero: translatePlural('fe.components.psf.promote_or_share.promoted_contributor_amount_hero', promoterCount, {
						custom_promoter_count: promoterCountLocalized,
						custom_contribution_amount: contributionAmountLocalized,
					}),
					signature: translatePlural(
						'fe.components.psf.promote_or_share.promoted_contributor_amount_signature',
						additionalSignatures,
						{
							custom_additional_signatures: additionalSignaturesLocalized,
						},
					),
				});
			}, [translate, translatePlural, joinTheCommunityCustomConfig, promoterCountText]),
		},
	};
}
